import { cn } from 'Utils/Helpers'
import { Typography } from 'procyon-ui'
import React from 'react'

function OverviewTab({ ResourceInfoComponent }) {
  return (
    <div className='flex flex-row gap-4 pr-2'>
      <div className={cn('w-2/4 grid-col-4 ')}>
        <Typography variant='h4-regular'>Resource Information</Typography>
        <div className='mt-12 pr-8'>{ResourceInfoComponent}</div>
      </div>
    </div>
  )
}

export { OverviewTab }
